import { ProductImage, ImageExtension } from 'returnCenter-api';
import noPictureSvg from 'assets/images/no_picture.svg';

export function getImage(image: ProductImage | undefined, type: ImageType, extension?: ImageExtension) {
    if (image?.customUrl) return image.customUrl;

    if (!image || image?.ext === undefined || image?.ext === null) {
        if (extension) {
            return MissingImage[extension];
        }
        return noPictureSvg;
    }

    const url = process.env.REACT_APP_MEDIASERVICEURL;
    const ext = ImageExtensions[extension ?? image.ext];

    return `${url}/${ImageTypes[type]}/${image.imageId}/${image.fileName}${ext}`;
}

export function getImageUrl(image: ProductImage | undefined, type: ImageType, extension?: ImageExtension) {
    if (image?.customUrl) return image.customUrl;

    if (!image || image?.ext === undefined || image?.ext === null) {
        return undefined;
    }

    const url = process.env.REACT_APP_MEDIASERVICEURL;
    const ext = ImageExtensions[extension ?? image.ext];

    return `${url}/${ImageTypes[type]}/${image.imageId}/${image.fileName}${ext}`;
}

export function imageSupportsTransparency(extension?: ImageExtension) {
    switch (extension) {
        case ImageExtension.Psd:
        case ImageExtension.Png:
        case ImageExtension.Webp:
            return true;
        default:
            return false;
    }
}

export enum ImageType {
    Pdf = 0,
    HighRes = 1,
    Preview = 2,
    LargeThumbNail = 3,
    ThumbNail = 4,
    Original = 5,
}
export const ImageTypes: Record<ImageType, string> = {
    [ImageType.Pdf]: 'pdf',
    [ImageType.HighRes]: 'highres',
    [ImageType.Preview]: 'preview',
    [ImageType.LargeThumbNail]: 'largethumbnail',
    [ImageType.ThumbNail]: 'thumbnail',
    [ImageType.Original]: 'original',
};

export const ImageExtensions: Record<ImageExtension, string> = {
    [ImageExtension.Psd]: '.webp',
    [ImageExtension.Svg]: '.svg',
    [ImageExtension.Png]: '.png', // might change to webp in the future
    [ImageExtension.Jpg]: '.jpg',
    [ImageExtension.Webp]: '.webp',
    [ImageExtension.Jpeg]: '.jpeg',
};

export const MissingImage: any = {
    [ImageExtension.Psd]: noPictureSvg,
    [ImageExtension.Svg]: noPictureSvg,
    [ImageExtension.Png]: noPictureSvg,
    [ImageExtension.Jpg]: noPictureSvg,
    [ImageExtension.Webp]: noPictureSvg,
    [ImageExtension.Jpeg]: noPictureSvg,
};

export default getImage;
